<template>
  <div class="custom-tooltip app-ctrl">
    <!-- Header Text -->
    <div class="pb-2">{{ params.value.text }}</div>

    <!-- Thresholds -->
    <div  v-if="params.value.thresholds"
          class="pb-2">
      <div  class="dim-number"
            v-for="(threshold, index) in params.value.thresholds"
            :key="index">
        <div  class="dim-rect" 
              :style="{ 'background': threshold.Color }">
        </div>

        <div style="text-align: -webkit-right;">
          {{ threshold.niceText }}
        </div>
      </div>
    </div>

    <!-- Targets -->
    <div  v-if="targets() !== undefined"
          class="pb-2">
      <div class="dim-number2"
            v-for="(target, index) in targets()"
            :key="index">
        <font-awesome-icon class="dim-icon mr-1" :icon="['fas', 'bullseye-arrow']" /> 
        <div v-if="target.direction == 'BELOW'">{{ $t('Webportal.CX.Grid.TargetBelow') }}</div>
        <div v-else>{{ $t('Webportal.CX.Grid.TargetAbove') }}</div>
        <div>{{ target.type == 'hour' ? getTime(target.value) : target.value }}</div>
        <font-awesome-icon class="dim-icon" v-if="target.type == 'star'" :icon="['fas', 'star']" />
        <div v-else-if="target.type == 'percent'">%</div>
        <div v-else-if="target.type == 'hour'">h</div>
        <div v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import dateTime from "./dateTime";

export default {
  data() {
    return {
      defaultTargets: [
        {
          direction: 'BELOW',
          type: 'hour',
          value: 90
        }
      ]
    };
  },
  
  methods: {
    targets() {
      if(this.params.value.targets && this.params.value.targets.length > 0) 
        return this.params.value.targets;
      if (!this.params.value.thresholds && !this.params.value.targets)
        return this.defaultTargets;
      return undefined;
    },

    getTime(minutes) {
      return dateTime.formatHoursMinutes(parseInt(minutes), false);
    },
  }
}
</script>

<style lang="scss" scoped>
  .custom-tooltip {
    border: 1px solid #BABFC7;
    font-weight: 600 !important;
    padding: 0.5rem;
    font-size: 14px;
  }

  .dim-number, .dim-number2 {
    display: grid;
    font-weight: 500 !important;
  }

  .dim-number {
    grid-template-columns: auto 1fr;
    grid-gap: 0.5rem;
    min-width: 8rem;
    max-width: 8rem;
    width: 8rem;
  }

  .dim-number2 {
    grid-template-columns: auto auto auto auto auto 1fr;
    grid-gap: 0.125rem;
  }

  .dim-icon, .dim-rect {
    width: 14px;
    height: 14px;
    border-radius: 2px;
  }

  .dim-icon {
    margin: 0.15rem 0.0rem 0.10rem 0.1rem;
  }
  
  .dim-rect {
    margin: 0.25rem 0.0rem 0.25rem 0rem!important;
  }
</style>